export default function Card({ title, action, children, className = "" }) {
  return (
    <div className={`bg-sable rounded-sm border border-marine/10 shadow-sm p-6 ${className}`}>
      {title && (
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-display text-xl text-marine">{title}</h2>
          {action}
        </div>
      )}
      {children}
    </div>
  );
}
